import { Injectable } from '@angular/core';
import { RestApi } from '@core/api/rest.api';
import { LeverandoerOpkraevningPeriode } from './leverandoer-opkraevning-periode.model';

@Injectable({
  providedIn: 'root',
})
export class LeverandoerOpkraevningPeriodeApi extends RestApi<LeverandoerOpkraevningPeriode> {
  endpoint = '/api/admin/leverandoeropkraevningperioder';
}
